import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { trackByRoute } from '@vex/utils/track-by';
import { filter, map, startWith } from 'rxjs/operators';

import { NavigationService } from '../../../../core/navigation/navigation.service';
import { NavigationItem, NavigationLink } from '../../../../core/navigation/navigation-item.interface';

@Component({
  selector: 'rms-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  imports: [MatRippleModule, NgClass, RouterLink, MatMenuModule, MatIconModule, NgTemplateOutlet, AsyncPipe],
})
export class NavigationItemComponent {
  @Input({ required: true }) item!: NavigationItem;
  private readonly navigationService = inject(NavigationService);
  private readonly router = inject(Router);
  isActive$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => (item: NavigationItem) => this.hasActiveChilds(item))
  );

  isLink = this.navigationService.isLink;
  isDropdown = this.navigationService.isDropdown;
  isSubheading = this.navigationService.isSubheading;
  isCallback = this.navigationService.isCallback;
  trackByRoute = trackByRoute;

  hasActiveChilds(parent: NavigationItem): boolean {
    if (this.isLink(parent)) {
      return this.router.isActive(parent.route as string, true);
    }

    if (this.isCallback(parent)) {
      return parent.isActive ?? false;
    }

    if (this.isDropdown(parent) || this.isSubheading(parent)) {
      return parent.children.some((child) => {
        if (this.isDropdown(child)) {
          return this.hasActiveChilds(child);
        }

        if (this.isLink(child) && !this.isFunction(child.route)) {
          return this.router.isActive(child.route as string, true);
        }

        return false;
      });
    }

    return false;
  }

  isFunction(prop: NavigationLink['route']) {
    return prop instanceof Function;
  }
}
